import React from 'react';
import DynamicLabelInput from './DynamicLabelInput';

const renderField = ({ input, label, showSuccess, type, autoComplete, meta: { asyncValidating, touched, error, valid, invalid, warning } }) => (
  <div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
    <div className={asyncValidating ? 'async-validating' : ''}>
        <DynamicLabelInput {...input} 
        	className="form-control" 
        	showLabel={['ftyc', 'fiduciaria', 'cuyoaval'].includes(process.env.PAGE)}
        	placeholder={label} 
        	type={type} 
        	autoComplete={autoComplete}/>
        <div className="help-block">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
  </div>
)

export default renderField;



/** WEBPACK FOOTER **
 ** ./src/components/renderField.js
 **/